import type { Markings } from '../config/types';

/**
 * Determine if the marking has a valid square or valid from/to properties.
 */
export function markingHasValidSquareOrFromTo(marking: Markings.Model): boolean {
  const { from, square, to } = marking.data;

  const squares = square ? [square] : [from, to];

  for (const s of squares) {
    if (!isBoardSquare(<string>s)) {
      return false;
    }
  }

  return true;
}

/**
 * Determine if a string is a SAN square on the board.
 */
function isBoardSquare(square: string): boolean {
  return /^([a-h][1-8])$/.test(square);
}
